export default {
  data: function() {
    return {
      screen: {
        height: 0,
        width: 0
      }
    };
  },
  computed: {
    isMediumScreen: function () {
      return this.screen.width >= 768 && this.screen.width < 992;
    },
    isLargeScreen: function () {
      return this.screen.width >= 992 && this.screen.width < 1200;
    },
    isExtraLargeScreen: function () {
      return this.screen.width >= 1200;
    }
  },
  created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.screen.width = window.innerWidth;
      this.screen.height = window.innerHeight;
    }
  }
};
